<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          required
          #webUserInput
          formControlName="webUser" 
          [matAutocomplete]="webUserAC" 
          (focus)="!webUserAC.isOpen && getInitialValues('webUser')" 
          >

        <mat-icon *ngIf="webUserInput.value" matSuffix svgIcon="close-circle-outline" (click)="clearForm($event)"></mat-icon>

        <mat-icon matSuffix svgIcon="menu-down" *ngIf="!webUserInput.value"></mat-icon>

        <mat-autocomplete #webUserAC="matAutocomplete" [displayWith]="displayFn" (closed)="autoCmpltClosed(); webUserInput.blur()">
          <mat-option
            disabled
            *ngIf="!loading.webUser && listData?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData" 
            >
            {{ data.username }}
          </mat-option>

          <mat-option *ngIf="loading.webUser" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('webUser').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('webUser').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_WEB_USER' | translate) } }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>